import { BetaBadge } from "./BetaBadge";

export function CollapsedBrandLogo() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-0.5 text-white"
      role="img"
      aria-label="Doculegis Beta"
    >
      <a
        href={import.meta.env.VITE_APP_URL || "/"}
        className="inline-flex"
        aria-label="Doculegis home"
      >
        <svg
          viewBox="0 0 28 45"
          className="h-7 w-auto shrink-0 aspect-[28/45]"
          fill="currentColor"
          aria-hidden
        >
          <path d="M5.78,34.35c-.23,0-.35-.12-.35-.35V9.81c0-.23.12-.35.35-.35h8.79c1.79,0,3.48.32,5.05.94,1.57.63,2.95,1.5,4.14,2.61,1.19,1.12,2.11,2.43,2.78,3.94.66,1.51.99,3.17.99,4.96s-.33,3.41-.99,4.92c-.66,1.51-1.59,2.83-2.78,3.94-1.19,1.12-2.56,1.99-4.14,2.62-1.57.63-3.25.94-5.05.94H5.78ZM11.05,29.68h3.8c1.28,0,2.48-.32,3.6-.98,1.12-.65,2.03-1.57,2.73-2.74.7-1.17,1.05-2.52,1.05-4.03s-.35-2.88-1.05-4.05c-.7-1.16-1.61-2.07-2.73-2.72-1.12-.65-2.32-.98-3.6-.98h-3.8c-.23,0-.35.12-.35.35v14.81c0,.23.12.35.35.35Z" />
        </svg>
      </a>
      <BetaBadge className="px-1 py-0 text-[7px] leading-none tracking-normal" />
    </div>
  );
}
